import { Skeleton } from '../ui/Skeleton';

export function HeatmapLoading() {
  return (
    <div className="space-y-2 p-4">
      {/* Title skeleton */}
      <Skeleton className="h-4 w-32" />
      
      {/* Subtitle skeleton */}
      <Skeleton className="h-3 w-48" />
      
      {/* Month labels */}
      <div className="mt-4 flex gap-2">
        {Array.from({ length: 12 }).map((_, i) => (
          <Skeleton key={i} className="h-3 w-8" />
        ))}
      </div>
      
      {/* Heatmap grid skeleton */}
      <div className="mt-2 space-y-1">
        {Array.from({ length: 7 }).map((_, row) => (
          <div key={row} className="flex gap-1">
            {Array.from({ length: 53 }).map((_, col) => (
              <Skeleton key={col} className="h-3 w-3 rounded-sm" />
            ))}
          </div>
        ))}
      </div>
      
      {/* Legend skeleton */}
      <div className="mt-3 flex gap-2">
        <Skeleton className="h-3 w-12" />
        {Array.from({ length: 6 }).map((_, i) => (
          <Skeleton key={i} className="h-3 w-3 rounded-sm" />
        ))}
        <Skeleton className="h-3 w-12" />
      </div>
    </div>
  );
}
